import { render, staticRenderFns } from "./CreateTrainingProgramForm.vue?vue&type=template&id=c3f4cbb6&scoped=true&"
import script from "./CreateTrainingProgramForm.vue?vue&type=script&lang=js&"
export * from "./CreateTrainingProgramForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f4cbb6",
  null
  
)

export default component.exports